
import React, { useEffect, useState } from "react";
import { Products } from "./Products";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const ProductsSection = ({lang}) => {

  const categories =useSelector((state) => state.cart.products);

  const [index,setIndex] = useState(0)

  

  const [animation,setAnimation] = useState(false)




  const [width, setWidth] = useState(window.innerWidth);
  
  useEffect(() => {

    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
  //  console.log(window.innerWidth);
    return () => window.removeEventListener("resize", handleResize);
    
  
  }, []);

  return (
    <section className=" mt-[8px] px-[3%]  bg-white w-full">
      <div className={`flex ${width >= 1000 ? '' : 'flex-col gap-1'}  pt-10 `} >
      <h2 style={{fontFamily:'CairoExtraBold'}} className= {`text-[#333333] ${lang === 'en' ? "text-left" : "text-right"} text-[20px]  xl:text-[50px]  lg:text-[40px] md:text-[30px]   sm:text-[25px]  xs:text-[20px] `} >
      {lang === 'en' ? "Suggested Products" : "منتجات مقترحة"} 
          </h2>
          <div  style={{overflowX:'auto'}} className="flex min-w-[70%] gap-2 p-1 ">
            {categories.map((category, i) => (
              <button
                key={i}
                onClick={()=>{
            
                 if(i!==index){
                 
                  setAnimation(true)
                  setTimeout(() => {
                    setIndex(i)
                 //   setProducts(category.products)
                    setAnimation(false);
                  }, 500)
                 }
                 
               //  console.log(JSON.stringify(category.products))
                }}
                className={`m-auto grow transition-all duration-500  px-1 py-1  rounded-xl shrink-0  ${
                  index === i
                    ? "text-white drop-shadow-lg bg-primary px-4    "
                    : "bg-zinc-100   " 
                } h-[50px] `}
              >
                {lang === 'en' ? category.value_en : category.value }
              </button>
            ))}
          </div>
      </div>
       
       {/* Custom <hr/> */}
      <div className="flex mt-6 max-w-full bg-zinc-300 h-[3px] w-full" />
    
     <Products lang={lang} products={categories.length > 0 ? categories[index].products :[]} animation={animation} />
     <div className="w-full flex">
          <Link to={'Products'} style={{fontFamily:'CairoBold'}} className="text-blue-500 mx-auto mt-2" >
          {lang === 'en' ? 'All Products' : 'كل المنتجات' } 
          </Link>
          </div>
    </section>
  );
};
